// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__HPJzP"};